import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=0a1a9c55&scoped=true&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=0a1a9c55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a9c55",
  null
  
)

export default component.exports